import XeroChangeLogView from "@/components/admin/XeroChangeLogView";
import {
  XERO_DIM_CUBE_MAPPINGS_LOGS_QUERY_KEY,
  getDimCubeMappingsLogs,
} from "@/services/xeroApi";

const FIELD_LABELS: Record<string, string> = {
  legacy_office: "Legacy office",
  legacy_office_reported: "Legacy office reported",
  site: "Site",
  legacy_location_reported: "Legacy location reported",
  mapping_perimeter: "Mapping perimeter",
  xero_inclusion_date: "Xero inclusion date",
};

const SOURCES = ["edit", "bulk_import", "cascade", "seed"] as const;


export default function XeroMappingsLogPage() {
  return (
    <XeroChangeLogView
      title="Mappings change log"
      labelHeading="Legacy office fetched"
      fieldLabels={FIELD_LABELS}
      sources={SOURCES}
      queryKey={XERO_DIM_CUBE_MAPPINGS_LOGS_QUERY_KEY}
      fetchPage={getDimCubeMappingsLogs}
      backTo="/datacore/xero?tab=mappings"
      backLabel="Back to Mappings"
    />
  );
}
